// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Dp-z","breadcrumbForward":"Ep-z","breadcrumbBack":"Fp-z","selected":"Gp-z"};